import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { InstallGpuExporterDialog } from './InstallGpuExporterDialog';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { ShowModalOutput } from '@cast/design-system';

export const useInstallGpuExporterDialog = () => {
  const modalRef = useRef<ShowModalOutput>(undefined);
  const { cluster } = useCluster();
  const { showModal } = useModal();

  const destroy = () => {
    modalRef.current?.destroy();
  };

  const openInstallGpuExporterDialog = () => {
    modalRef.current = showModal(
      InstallGpuExporterDialog,
      {
        cluster,
        destroy,
      },
      { rootId: 'root' }
    );
  };

  return { openInstallGpuExporterDialog };
};
